<template>
    <div class="findPwd">
       <forget-pwdTitle :active="0"></forget-pwdTitle>
        <div class="findPwd-page_main">
            <el-form class="findPwd-page_form"  label-width="80px" :model="ruleForm" ref="ruleForm">
                <el-form-item prop="email" label="邮箱地址" :error="emailErr">
                    <el-input v-model="ruleForm.email" class="emailAddr" @focus="clearErr('email')" maxlength="25">
                    </el-input>
                    <span class="emailName">@tongji.edu.cn</span>
                </el-form-item>
                <el-form-item class="findPwd-page_submit">
                    <el-button type="primary" @click="submitForm('ruleForm')">下一步</el-button>
                </el-form-item>
            </el-form>
            
        </div>

    </div>
</template>

<script>
import ForgetPwdTitle from '../../public/forgetPwdTitle'
export default {
    name: 'findPwdStep1',
    components: {
      forgetPwdTitle:ForgetPwdTitle
    },
    data(){
        return{
           ruleForm:{
               email:""
           },
           emailErr:""
        }
    },
    methods:{
        submitForm(){
            const self = this
            if(!self.ruleForm.email){
                self.emailErr = "请输入邮箱地址"
            }else{
                const url = '/email/userExist?xgh='+self.ruleForm.email
                self.postRequest(url,{}).then((result)=>{
                    console.log("邮箱地址",result.data)
                    if(result.data&&result.data.msgStatus == 1){
                        localStorage.setItem("findPwdXGH",self.ruleForm.email)
                        localStorage.setItem("emailToken",result.data.msgCode)
                        self.$router.push({ name: 'Step2'})
                        // self.$router.push({ name: 'Step3'})
                    }else{
                        self.emailErr="邮箱地址不存在"
                    }
               })
            }
            
        },
        clearErr(val){
            this.emailErr=""
        }
    }
    
}
</script>

<style scoped>
.forgetPwd{
    width: 100%;
}
.emailAddr{
  width: 195px;
}
.emailName{
    display: inline-block;
    border: 1px solid #dcdfe6;
    width: 170px;
    text-align: center;
    margin-left: -12px;
    line-height: 38px;
  }
.findPwd-page_main{
    width: 782px;
    margin: 0 auto;
    background: #FBFBFD;
    margin-top: 50px;
    padding: 50px 0;
}
.findPwd-page_form{
    width: 440px;
    margin: 0 auto;

}
.findPwd-page_submit{
    margin-top: 50px;
}
.findPwd-page_submit button{
        width: 130px;
        height: 40px;
        line-height: 40px;
        padding: 0;
        color: #fff;
        font-size: 16px;
}

</style>



// WEBPACK FOOTER //
// src/page/reSetPwd/step1.vue